export default __webpack_public_path__ + "static/media/footer_logo.6ff1dec9.png";